import { useCallback, useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { noneFilter, toJavaScriptString } from './calculator';

const cookies = new Cookies();

export const setCookie = (name, value, options) => {
	return cookies.set(name, value, { ...options });
};

export const getCookie = name => {
	return cookies.get(name);
};

export const getAllCookie = () => {
	return cookies.getAll();
};

export const removeCookie = name => {
	return cookies.remove(name, { path: '/' });
};

export const useAuth = () => {
	const [cookieState, setCookieState] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);

	const getEmail = useCallback(() => {
		try {
			const arc_login_Y = getCookie('ArcId.USER_INFO');
			const arc_login_N = getCookie('ArcId.USER_INFO.session');

			// 디버깅 로그 추가

			if (!noneFilter.includes(arc_login_Y)) {
				const JObject = JSON.parse(arc_login_Y);
				const decode_accessToken = JObject.accessToken.split('.')[1];
				const decodedData = decodeURIComponent(escape(atob(decode_accessToken)));
				const accessTokenObj = JSON.parse(decodedData);

				setCookieState(accessTokenObj);
				return;
			}

			if (!noneFilter.includes(arc_login_N)) {
				const cleanedString = toJavaScriptString(arc_login_N);
				const JObject = JSON.parse(cleanedString);
				const decode_accessToken = JObject.accessToken.split('.')[1];
				const decodedData = decodeURIComponent(escape(atob(decode_accessToken)));
				const accessTokenObj = JSON.parse(decodedData);

				setCookieState(accessTokenObj);
				return;
			}
		} catch (error) {
			document.cookie = 'ArcId.USER_INFO=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
			setCookieState(null);
			setError('로그인 정보가 만료되었습니다.');
		} finally {
			setIsLoading(false);
		}
	}, []);

	useEffect(() => {
		getEmail();
	}, [getEmail]);

	// A 페이지에서는 이렇게 사용
	return {
		cookieState,
		isLoading, // isLoading으로 로딩 상태 체크 필요
		error,
	};
};
